import React from 'react';
import { Paper, useTheme } from '@mui/material';
import Markdown from 'react-markdown';

interface AIMarkdownProps {
  markdownContent: string;
}

// Tooltip content component
export default function AIMarkdown(props: AIMarkdownProps): JSX.Element {
  const theme = useTheme();

  return (
    <Markdown
      components={{
        blockquote(props) {
          const {node, ...rest} = props
          return <Paper sx={{
            color: theme.palette.text.secondary,
            padding: "1px 15px",
            margin: "15px 0 5px 10px"}} {...rest} />
        }
      }}
    >
      {props.markdownContent}
    </Markdown>
  );
};
